import React, { FC } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  CLIENT_DETAILS, DOCTORS_ROUTE, MEDICARE_AND_HEALTH, SPECIALITIES_ROUTE,
} from '../../constants/routes';
import { BOOKING_STEPS, isDirectClinicianLink } from '../../utils/booking-flow';
import { useAppointmentSummary } from '../BookingSummary';

const TITLES = ['Book your appointment', 'Your details', 'Medicare & health', 'Review & consent', 'Booking confirmed'];
const BACK_TO = [undefined, DOCTORS_ROUTE, CLIENT_DETAILS, MEDICARE_AND_HEALTH];

const BackChevron: FC = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <path d="M15 18l-6-6 6-6" />
  </svg>
);

// Phones only (styled in uplift.css): the ADHD portal's sticky step header.
const MobileStepHeader: FC<{ step: number }> = ({ step }) => {
  const navigate = useNavigate();
  const { pathname, search } = useLocation();
  const { clinician, when } = useAppointmentSummary();
  const complete = step >= BOOKING_STEPS.length;

  // On the appointment step, Back leaves a specialty's clinician list for the specialty list.
  const browsingSpecialty = step === 0 && pathname.startsWith(DOCTORS_ROUTE) && !isDirectClinicianLink(search);
  const backTo = browsingSpecialty ? SPECIALITIES_ROUTE : BACK_TO[step];
  const backSearch = browsingSpecialty ? '' : search;

  const subtitle = [clinician, when].filter(Boolean).join(' · ') || 'Telehealth with Telecare';
  const progress = complete ? 100 : ((step + 1) / BOOKING_STEPS.length) * 100;

  return (
    <header className="mhead m-only">
      <div className="row">
        <button
          type="button"
          className={`back${backTo ? '' : ' ph'}`}
          aria-label="Back"
          tabIndex={backTo ? 0 : -1}
          onClick={() => backTo && navigate(`${backTo}${backSearch}`)}
        >
          <BackChevron />
        </button>
        <div className="tt">
          <b>{TITLES[step]}</b>
          <small>{subtitle}</small>
        </div>
        <span className={`chip-step${complete ? ' done' : ''}`}>
          {complete ? 'Done' : `Step ${step + 1} of ${BOOKING_STEPS.length}`}
        </span>
      </div>
      <div className="prog"><i style={{ width: `${progress}%` }} /></div>
    </header>
  );
};

export default MobileStepHeader;
